import React, { useRef, useState } from "react";
import Select from "react-select";
import EmailEditor from "react-email-editor";

const EmailBuilder = () => {
  const [formData, setData] = useState({
    code: "",
    sender: "",
    subject: "",
    body: "",
    query: "",
    isRepeat: false,
    repeat_on: [],
    scheduled_date: "",
    scheduled_time: "",
  });

  const emailEditorRef = useRef(null);

  const handleExport = () => {
    if (emailEditorRef.current) {
      emailEditorRef.current.exportHtml((data) => {
        const { design, html } = data;
        setData((prevData) => ({
          ...prevData,
          body: html, // Save the HTML body in state
        }));
        console.log("Design JSON:", design);
        console.log("HTML Output:", html);
      });
    } else {
      console.error("EmailEditor is not loaded yet.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleRepeatChange = (selectedOptions) => {
    setData((prevData) => ({
      ...prevData,
      repeat_on: selectedOptions.map((option) => option.value),
    }));
  };

  const handleSave = () => {
    console.log("Complete Form Data:", formData);
  };

  const repeatOptions = [
    { label: "Every Monday", value: "Monday" },
    { label: "Every Tuesday", value: "Tuesday" },
    { label: "Every Wednesday", value: "Wednesday" },
    { label: "Every Thursday", value: "Thursday" },
    { label: "Every Friday", value: "Friday" },
    { label: "Every Saturday", value: "Saturday" },
    { label: "Every Sunday", value: "Sunday" },
  ];

  return (
    <div className="container-fluid bg-info-subtle">
      <div className="container-sm py-3">
        <div className="header">
          <h3>Email Builder</h3>

          <div className="form">
            <div className="form-group mb-3">
              <label className="form-label">Template Code</label>
              <input
                type="text"
                className="form-control"
                name="code"
                value={formData.code}
                onChange={handleInputChange}
                placeholder="Enter Template Code"
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Sender Email</label>
              <Select
                options={[
                  { label: "email@example.com", value: "email@example.com" },
                ]}
                placeholder="Select Sender Email"
                onChange={(selected) =>
                  setData((prevData) => ({
                    ...prevData,
                    sender: selected.value,
                  }))
                }
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Subject</label>
              <input
                type="text"
                className="form-control"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                placeholder="Enter Email Subject"
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Body</label>
              <div className="card">
                <div className="card-body">
                  <EmailEditor ref={emailEditorRef} />
                </div>
              </div>
              <button className="btn btn-secondary mt-2" onClick={handleExport}>
                Generate Body
              </button>
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Student Query</label>
              <input
                type="text"
                className="form-control"
                name="query"
                value={formData.query}
                onChange={handleInputChange}
                placeholder="values should be passed as [StudentId, Email, Name, StudentCode]"
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Repeat Email</label>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="isRepeat"
                  checked={formData.isRepeat}
                  onChange={handleInputChange}
                />
                <label className="form-check-label">Repeat</label>
              </div>
            </div>

            {formData.isRepeat && (
              <div className="form-group mb-3">
                <label className="form-label">Repeat On</label>
                <Select
                  options={repeatOptions}
                  isMulti
                  onChange={handleRepeatChange}
                  placeholder="Select Repeat Days"
                />
              </div>
            )}

            {!formData.isRepeat ? (
              <div className="row">
                <div className="col-md-6 form-group mb-3">
                  <label className="form-label">Scheduled Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="scheduled_date"
                    value={formData.scheduled_date}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6 form-group mb-3">
                  <label className="form-label">Scheduled Time</label>
                  <input
                    type="time"
                    className="form-control"
                    name="scheduled_time"
                    value={formData.scheduled_time}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            ) : null}

            <div className="text-end mt-3">
              <button className="btn btn-primary" onClick={handleSave}>
                Save Email
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailBuilder;
